const loadScript = (url) => {
  if (window.thebelab !== undefined) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = Object.assign(document.createElement('script'), {
      src: url,
      async: true,
      onload: resolve,
      onerror: reject,
    });

    document.head.appendChild(script);
  });
};

export default loadScript;
